// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Partition-module__ui-Partition--CaoSA {
  display: flex;
  align-items: stretch;
}

.Partition-module__ui-Partition--CaoSA.Partition-module__direction-horizontal--pUGst {
  flex-direction: row;
}

.Partition-module__ui-Partition--CaoSA.Partition-module__direction-vertical--Rc9y2 {
  flex-direction: column;
}

.Partition-module__ui-Partition-Item--xxqAl {
  display: flex;
  flex: none;
}

.Partition-module__ui-Partition-Item--xxqAl + .Partition-module__ui-Partition-Item--xxqAl {
  flex: 1;
}

.Partition-module__ui-Partition-Item--xxqAl > * {
  flex: 1;
}`, "",{"version":3,"sources":["webpack://./../../packages/design-system/src/components/Partition/Partition.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,UAAU;AACZ;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,OAAO;AACT","sourcesContent":[".ui-Partition {\n  display: flex;\n  align-items: stretch;\n}\n\n.ui-Partition.direction-horizontal {\n  flex-direction: row;\n}\n\n.ui-Partition.direction-vertical {\n  flex-direction: column;\n}\n\n.ui-Partition-Item {\n  display: flex;\n  flex: none;\n}\n\n.ui-Partition-Item + .ui-Partition-Item {\n  flex: 1;\n}\n\n.ui-Partition-Item > * {\n  flex: 1;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"ui-Partition": `Partition-module__ui-Partition--CaoSA`,
	"direction-horizontal": `Partition-module__direction-horizontal--pUGst`,
	"direction-vertical": `Partition-module__direction-vertical--Rc9y2`,
	"ui-Partition-Item": `Partition-module__ui-Partition-Item--xxqAl`
};
export default ___CSS_LOADER_EXPORT___;
